import React, { useCallback, useEffect, useState } from "react";
import { IActions, IFilters, userProps } from "../../../interfaces";
import { getFilterFields } from "../../../utils/filterFields";
import { ITable } from "../../../components/TableList";
import { useApi } from "../../../hooks/api";
import { useGlobal } from "../../../hooks/global";
import { setUpConsultation } from "../../../services/generalServices";
import { MdDelete } from "react-icons/md";
import { secondary } from "../../../theme";
import { IPermissionsTypes } from "../../../utils/permissions";
import { PageList } from "../../../components/PageList";
import { ModalUser } from "../../../components/Modals/ModalUser";
import { positionTypeOptions } from "../../../utils/options";

const initialFilters: IFilters[] = [getFilterFields("user_type_id")];

const initialTable: ITable = {
  data: [],
  columns: [
    {
      attr: "surname",
      name: "Apelido",
      limitWidth: true,
      style: {},
      styleContent: { fontSize: 16, fontWeight: 600 },
    },
    {
      attr: "email",
      name: "Email",
      limitWidth: true,
      style: {},
      styleContent: {},
    },
    {
      attr: "phone",
      name: "Telefone",
      limitWidth: true,
      style: {},
      styleContent: {},
    },
    {
      attr: "position",
      name: "Cargo",
      limitWidth: true,
      style: {},
      styleContent: {},
    },
  ],
};

export const UsersRemarketingRoot: React.FC = () => {
  const { user, api } = useApi();
  const { theme, paginationLimit, notify } = useGlobal();

  const [atualPage, setAtualPage] = useState(1);
  const [filters, setFilters] = useState<any>({});
  const [openModal, setOpenModal] = useState(false);
  const [numOfPersons, setNumOfPersons] = useState(0);
  const [updatedAt, setUpdatedAt] = useState(new Date());
  const [loadingPersons, setLoadingPersons] = useState(true);
  const [searchString, setSearchString] = useState<string>("");
  const [numberOfPages, setNumberOfPages] = useState<number>(1);
  const [userSelected, setUserSelected] = useState<userProps | null>(null);
  const [table, setTable] = useState<ITable>(initialTable);

  const changeStatusUser = useCallback(
    async (userId: string, old_status: boolean) => {
      const new_active = !old_status;

      setTable((atual) => {
        const new_table = { ...atual };
        const pos = new_table.data.findIndex((d) => d?.this.id === userId);
        if (pos !== -1) new_table.data[pos].this.active = new_active;
        return { ...new_table };
      });

      try {
        await api.put(`/users-remarketing/${userId}`, { active: new_active });
        notify("Status do usuário atualizado com sucesso.", "success");
      } catch (err) {
        notify("Erro ao alterar status do usuário.", "error");
        setTable((atual) => {
          const new_table = { ...atual };
          const pos = new_table.data.findIndex((d) => d?.this.id === userId);
          if (pos !== -1) new_table.data[pos].this.active = old_status;
          return { ...new_table };
        });
      }
    },
    []
  );

  const selectUser = useCallback((customer: userProps) => {
    setUserSelected({ ...customer });
    setOpenModal(true);
  }, []);

  const searchUsers = useCallback(
    async (page, _filters = null) => {
      setAtualPage(page);
      setLoadingPersons(true);
      try {
        const filters_obj = _filters
          ? _filters
          : { ...filters, search: searchString };

        let string = setUpConsultation(filters_obj);
        let url = `/users-remarketing?page=${page}&limit=${paginationLimit}&${string}`;

        const result = await api.get(url);
        const new_users = result.data.data as userProps[];
        setTable((atual) => {
          const new_table = { ...atual };
          new_table.data = [];
          new_users.forEach((user) => {
            new_table.data.push({
              id: user.id,
              surname: user.surname,
              email: user.email,
              phone: user.phone,
              this: user,
              position: positionTypeOptions.find((option) => option.value === user?.position)?.label,
            });
          });
          return { ...new_table };
        });

        setNumOfPersons(result.data.count);
        setNumberOfPages(Math.ceil(result.data.count / paginationLimit));
        setUpdatedAt(new Date());
      } catch (err) {
        notify("Erro na busca pelos usuários!", "error");
      }
      setLoadingPersons(false);
    },
    [user, filters, searchString, theme]
  );

  const handleConfirmDeleteCheckIn = useCallback(
    async (id: string) => {
      setLoadingPersons(true);

      try {
        await api.put(`users-remarketing/delete/${id}`);

        notify("Usuário excluído com sucesso!", "success");

        await searchUsers(1);
      } catch (error: any) {
        const default_message = "Erro ao excluir user!";

        const message = error.response?.data?.detail ?? default_message;
        notify(message, message === default_message ? "error" : "alert");
      }

      setLoadingPersons(false);
    },
    [searchUsers]
  );

  const alertDelete = useCallback(
    async (item: any): Promise<void> => {

      const result = window.confirm(
        "Tem certeza que deseja excluir o usuário: " +
        item.surname.toUpperCase()
      );

      if (result) handleConfirmDeleteCheckIn(item.id as unknown as string);
    },
    [handleConfirmDeleteCheckIn]
  );


  const openModalNewUser = useCallback(() => {
    setUserSelected(null);
    setOpenModal(true);
  }, []);

  const handleAction = (action_id: string) => {
    if (action_id === "new_item") openModalNewUser();
  };

  const actionsInitial: IActions[] = [  ];

  const onSaveUser = useCallback(() => {
    setOpenModal(false);
    searchUsers(1);
  }, [user, filters, searchString]);

  const listActions = [
/*     {
      title: "Editar",
      onClick: (user: userProps) => selectUser(user),
      icon: <FaEdit color={secondary[theme]} size={20} />,
      disabled: () => !user.user_type.permissions.includes("USERS-UPDATE" as IPermissionsTypes),
    }, */
    {
      title: "Excluir",
      onClick: (user: userProps) => alertDelete(user),
      icon: <MdDelete color={secondary[theme]} size={20} />,
      disabled: () => false,
    },
  ];

  useEffect(() => {
    searchUsers(1);
  }, [theme]);

  return (
    <PageList
      updatedAt={updatedAt}
      loading={loadingPersons}
      setLoading={setLoadingPersons}
      numberOfItems={numOfPersons}
      actions={actionsInitial}
      onClickOption={handleAction}
      textHeader="Usuários Remarketing"
      textItems="usuários Remarketing encontrados"
      text_loading={"Buscando Usuários Remarketing"}
      text_empty={"Nenhum usuário Remarketing encontrado"}
      theme={theme}
      initialFilters={initialFilters}
      onChangeFilters={setFilters}
      table={table}
      listActions={listActions}
      moduleName="users"
      pages={numberOfPages}
      page={atualPage}
      search={searchUsers}
      onChangeSearch={setSearchString}
      have_status={user.user_type.permissions.includes(
        "USERS-UPDATE" as IPermissionsTypes
      )}
      status_action={changeStatusUser}
    >
      {openModal && (
        <ModalUser
          onCancel={() => setOpenModal(false)}
          onSave={onSaveUser}
          openModal={openModal}
          backgroundVisible={false}
          defaultId={userSelected?.id}
        />
      )}
    </PageList>
  );
};
